import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Search, AlertTriangle } from "lucide-react";
import {
  server_post_data,
  ipass_switch,
} from "../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";
const SwitchIPassModal = ({
  show,
  onHide,
  currentIPass,
  availableIPasses,
  onSwitchComplete,
  carData,
  totalIpass,
  carIpass,
  master_data_get,
}) => {
  const [selectedIPass, setSelectedIPass] = useState(null);
  const [switchNotes, setSwitchNotes] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredIPasses, setFilteredIPasses] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  // Reset selected I-Pass when modal opens
  useEffect(() => {
    if (show) {
      setSelectedIPass(null);
      setSwitchNotes("");
      setSearchQuery("");
      setFilteredIPasses(availableIPasses);
    }
  }, [show, availableIPasses]);

  // Handle search filtering
  useEffect(() => {
    if (availableIPasses) {
      const filtered = availableIPasses.filter((ipass) =>
        ipass.ipass_id.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredIPasses(filtered);
    }
  }, [searchQuery, availableIPasses]);

  // Handle selection
  const handleIPassSelect = async (ipass) => {
    setSelectedIPass(ipass);
  };

  // Open confirmation modal
  const openConfirmation = () => {
    setShowConfirmation(true);
  };

  // Process switch after confirmation
  const processSwitch = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("car_id", carData?.car_id);
    fd.append("ipass_id", selectedIPass.primary_id);
    fd.append("ipass_number", selectedIPass.ipass_id);
    fd.append("booking_id", carData.primary_id);
    fd.append("ipass_assign_notes", switchNotes);

    await server_post_data(ipass_switch, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          onSwitchComplete(currentIPass, selectedIPass, switchNotes);
          setShowConfirmation(false);
          onHide();
          master_data_get();
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className="switchipass-modal"
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>Switch I-Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid p-0">
            {/* Current I-Pass Information */}
            <div className="switchipass-current mb-4">
              <h5 className="switchipass-section-title">
                Currently Assigned I-Pass
              </h5>
              {currentIPass ? (
                <div className="card switchipass-card p-3">
                  <div className="row">
                    <div className="col-md-6">
                      <p className="switchipass-label">I-Pass Number:</p>
                      <p className="switchipass-value">
                        {carIpass && carIpass[0]?.ipass_id}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="switchipass-label">Assigned To:</p>
                      <p className="switchipass-value">
                        {carData ? carData.car_data[0]?.car_name : "—"}
                      </p>
                    </div>
                    <div className="col-md-12 mt-2">
                      <div className="alert alert-warning switchipass-alert d-flex align-items-center">
                        <AlertTriangle size={18} className="me-2" />
                        <div>
                          This I-Pass will be unassigned and returned to the
                          available pool.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="alert alert-info">
                  No I-Pass currently assigned
                </div>
              )}
            </div>

            {/* Search for available I-Passes */}
            <div className="switchipass-available mb-4">
              <h5 className="switchipass-section-title">Select New I-Pass</h5>
              <div className="input-group switchipass-search-group mb-3">
                <span className="input-group-text">
                  <Search size={18} />
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by I-Pass number"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              {/* Available I-Passes list */}
              <div className="switchipass-list-container">
                {filteredIPasses && filteredIPasses.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover switchipass-table">
                      <thead className="table-light">
                        <tr>
                          <th>I-Pass Number</th>
                          <th>Status</th>
                          <th>Created Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {totalIpass &&
                          totalIpass.length > 0 &&
                          totalIpass.map((ipass) => (
                            <tr
                              key={ipass.primary_id}
                              className={
                                selectedIPass?.primary_id === ipass.primary_id
                                  ? "table-active"
                                  : ""
                              }
                            >
                              <td>{ipass.ipass_id}</td>
                              <td>
                                <span className="badge rounded-pill ipass-badge-available">
                                  Available
                                </span>
                              </td>
                              <td>{ipass.ipass_date}</td>
                              <td>
                                <button
                                  className={`btn btn-sm ${
                                    selectedIPass?.primary_id ===
                                    ipass.primary_id
                                      ? "btn-success"
                                      : "btn-outline-primary"
                                  }`}
                                  onClick={() => handleIPassSelect(ipass)}
                                >
                                  {selectedIPass?.primary_id ===
                                  ipass.primary_id
                                    ? "Selected"
                                    : "Select"}
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info">
                    No available I-Passes found
                  </div>
                )}
              </div>
            </div>

            {/* Notes section */}
            <div className="switchipass-notes mb-3">
              <label
                htmlFor="switchNotes"
                className="form-label switchipass-form-label"
              >
                Notes (Optional)
              </label>
              <textarea
                id="switchNotes"
                className="form-control"
                rows="3"
                value={switchNotes}
                onChange={(e) => setSwitchNotes(e.target.value)}
                placeholder="Add any additional notes about this I-Pass switch"
              ></textarea>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={onHide}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
            }}
            onClick={openConfirmation}
            disabled={!selectedIPass}
          >
            Switch I-Pass
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        show={showConfirmation}
        onHide={() => setShowConfirmation(false)}
        centered
        className="switchipass-confirmation-modal"
      >
        <Modal.Header
          style={{ backgroundColor: "var(--primary-color)" }}
          closeButton
        >
          <Modal.Title style={{ color: "#fff" }}>
            Confirm I-Pass Switch
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you want to switch from I-Pass{" "}
            <strong>{carIpass && carIpass[0]?.ipass_id}</strong> to{" "}
            <strong>{selectedIPass?.ipass_id}</strong>?
          </p>
          <p className="text-muted">
            This will unassign the current I-Pass from{" "}
            {carData ? carData.car_data[0]?.car_name : "the vehicle"} and assign
            the new I-Pass.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowConfirmation(false)}>
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: "var(--primary-color)",
              border: "none",
            }}
            onClick={processSwitch}
          >
            Confirm Switch
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SwitchIPassModal;
